import React from 'react';
import SimpleApp from './components/SimpleApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <SimpleApp />
    </div>
  );
}

export default App;
